export const trTranslations = {
  // Turkish translations
  'nav.home': 'Ana Sayfa',
  'nav.findPlaces': 'Yer Bulun',
  'nav.ratePlace': 'Yer Değerlendirin',
  'nav.ratePlaces': 'Yer Değerlendirin',
  'nav.login': 'Giriş',
  'nav.signup': 'Kaydol',
  'nav.logout': 'Çıkış',
  'nav.profile': 'Profil',
  'nav.admin': 'Yönetim',
  'nav.menu': 'Menü',
  'nav.account': 'Hesap',
  'nav.favorites': 'Favorileriniz',
  'favorites.description': 'Favorilere eklediğiniz işletmeler',
  // Pagination
  'pagination.previous': 'Önceki',
  'pagination.next': 'Sonraki',
  'pagination.goTo': 'Sayfaya git:',
  'pagination.go': 'Git',
  'pagination.of': ' / ',
  'hero.title': 'En İyisini Bulun — Gerisini Atlayın',
  'hero.subtitle': 'En iyisini bulun — en kötüsünden kaçının! Tek bir tıklamayla gerçek müşteri deneyimlerine dayanarak en sevdiğiniz restoranlara, spor salonlarına, eğlence merkezlerine ve daha fazlasına oy verin veya keşfedin!',
  'cta.findPlaces': 'Yer Bulun',
  'cta.ratePlace': 'Yer Değerlendirin',
  'howItWorks.title': 'Nasıl Çalışır',
  'howItWorks.step1': 'Bir işletme arayın',
  'howItWorks.step2': 'Olumlu ve olumsuz oyları görün',
  'howItWorks.step3': 'Kendi oyunuzu verin',
  'featured.title': 'Öne Çıkan Yerler',
  // Maintenance page
  'maintenance.title': 'Site Bakımda',
  'maintenance.defaultMain': 'Şu anda iyileştirmeler yapıyoruz, yakında tekrar çevrimiçi olacağız!',
  'maintenance.thankYou': 'Sabırınız için teşekkürler',
  'filters.categories': 'Kategori',
  'filters.cities': 'Şehir',
  'filters.selected': 'seçildi',
  'businessCard.address': '{0}',
  'businessCard.hours': '{0}',
  'businessCard.phone': '{0}',
  'businessCard.full': 'Tam',
  'whyTrustUs.title': 'Neden Bize Güvenmelisiniz',
  'whyTrustUs.community': '%100 Topluluk Odaklı',
  'whyTrustUs.realVotes': 'Sahte yorumlar değil, sadece gerçek oylar',
  'signup.title': 'Bir hesap için kaydolun',
  'signup.button': 'Şimdi Katılın',
  'footer.quickLinks': 'Hızlı Bağlantılar',
  'footer.information': 'Bilgi',
  'footer.about': 'Hakkımızda',
  'footer.contact': 'İletişim',
  'footer.reachOut': 'İletişim Kurun',
  'buttons.viewDetails': 'Detayları Gör',
  'buttons.viewAll': 'Tümünü Gör',
  'buttons.refresh': 'Yenile',
  'buttons.viewAllPlaces': 'Tüm Yerleri Gör',
  'footer.terms': 'Kullanım Koşulları',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.rights': 'Tüm Hakları Saklıdır',
  'footer.socialNetworks': 'Sosyal Ağlar',
  
  // Profile page translations
  'profile.title': 'Profil',
  'profile.accountInformation': 'Hesap Bilgileri',
  'profile.email': 'Email',
  'profile.firstName': 'Ad',
  'profile.lastName': 'Soyad',
  'profile.saveChanges': 'Değişiklikleri Kaydet',
  'profile.saving': 'Kaydediliyor...',
  'profile.validation.nameRequired': 'Ad veya soyad en az 3 harf içermelidir',
  'profile.validation.nameTaken': 'Bu ad veya soyad zaten kullanılıyor. Lütfen başka bir tane seçin.',
  'profile.validation.nameReserved': 'Bu ad veya soyad rezerve edilmiştir ve kullanılamaz.',
  'profile.validation.nameBadWord': 'Ad veya soyad uygunsuz kelimeler içeriyor.',
  'profile.updateSuccess': 'Profil Güncellendi',
  'profile.updateSuccessDescription': 'Profiliniz başarıyla güncellendi.',
  'profile.updateError': 'Hata',
  'profile.updateErrorDescription': 'Profil güncellenemedi. Lütfen tekrar deneyin.',
  'profile.accountActions': 'Hesap İşlemleri',
  'profile.signOutDescription': 'Hesabınızdan çıkmak istiyorsanız, aşağıdaki düğmeye tıklayın.',
  'profile.signOut': 'Çıkış Yap',
  'profile.yourActivity': 'Aktiviteniz',
  'profile.activityDescription': 'Oylarınızı, değerlendirmelerinizi ve yorumlarınızı görüntüleyin',
  'profile.adminTools': 'Yönetici Araçları',
  'profile.updateAdminProfiles': 'Yönetici Profillerini Güncelle',
  
  // Auth translations
  'auth.signIn': 'Giriş Yap',
  'auth.signUp': 'Kaydol',
  'auth.signInWithGoogle': 'Google ile Giriş Yap',
  'auth.email': 'Email',
  'auth.password': 'Şifre',
  'auth.error': 'Hata',
  'auth.success': 'Başarılı',
  'auth.loginDescription': 'Hesabınıza erişmek için bilgilerinizi girin',
  'auth.signupDescription': 'Topluluğumuza katılmak için yeni bir hesap oluşturun',
  'auth.forgotPassword': 'Şifreni mi unuttun?',
  'auth.resetPassword': 'Şifre Sıfırla',
  'auth.enterEmailForReset': 'Email adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.',
  'auth.emailRequired': 'Email gerekli',
  'auth.emailNotRegistered': 'Bu email kayıtlı değil. Lütfen kayıt olduğunuz email\'i kullanın.',
  'auth.resetEmailSent': 'Şifre sıfırlama emaili gönderildi! Email kutunuzu kontrol edin.',
  'auth.emailSent': 'Email Gönderildi!',
  'auth.checkEmailInbox': 'Lütfen email kutunuzu kontrol edin ve şifrenizi sıfırlamak için talimatları takip edin.',
  'auth.close': 'Kapat',
  'auth.sending': 'Gönderiliyor...',
  'auth.signingIn': 'Giriş yapılıyor...',
  'auth.signingUp': 'Kaydolunuyor...',
  'auth.emailPlaceholder': 'sizin@email.com',
  'auth.fillAllFields': 'Lütfen tüm alanları doldurun',
  'auth.accountCreated': 'Hesap başarıyla oluşturuldu! Onay için e-postanızı kontrol edin.',
  'auth.loggedIn': 'Başarıyla giriş yapıldı!',
  'auth.failed': 'Kimlik doğrulama başarısız oldu',
  'auth.processing': 'İşleniyor...',
  'auth.noAccount': 'Hesabınız yok mu?',
  'auth.haveAccount': 'Zaten hesabınız var mı?',
  'auth.firstNameRequired': 'Ad gerekli',
  'auth.lastNameRequired': 'Soyad gerekli',
  'auth.firstName': 'Ad',
  'auth.lastName': 'Soyad',
  'auth.continueWith': 'VEYA DEVAM ET',
  'search.placeholder': 'Yer ara...',
  'search.submit': 'Ara',
  'search.byBusinessName': 'İşletme adına göre ara...',
  'search.businessesFound': '{0} işletme bulundu',
  'search.showingOf': '({1} işletmenin {0} gösteriliyor)',
  'search.showingBusinesses': '{1} işletmeden {0} gösteriliyor',
  'search.loadingBusinesses': 'İşletmeler yükleniyor...',
  'search.searchingBusinesses': 'İşletmeler aranıyor...',
  'search.loadingMoreBusinesses': 'Daha fazla işletme yükleniyor...',
  'search.nextBusinesses': 'Sonraki 50 İşletme',
  // Business list messages
  'businesses.noResults': 'Seçilen filtrelerle eşleşen işletme bulunamadı.',
  'businesses.loadError': 'İşletmeler yüklenemedi. Lütfen sayfayı yenilemeyi deneyin.',
  'rating.service': 'Hizmet',
  'rating.cleanliness': 'Temizlik',
  'rating.pricing': 'Fiyatlandırma',
  'rating.interior': 'İç Dekorasyon',
  'business.information': 'İşletme Bilgileri',
  'business.reviews': 'Yorumlar',
  'business.ratingsTitle': 'Değerlendirmeler',
  'business.overallRating': 'Genel Değerlendirme',
  'business.ratingCategories': 'Değerlendirme Kategorileri',
  'business.website': 'Website',
  'business.googleMaps': 'Google Maps\'te Görüntüle',
  'business.placeOrder': 'Sipariş Ver',
  'business.chooseDeliveryService': 'Teslimat Hizmeti Seçin',
  'business.performanceComparison': 'Performans Karşılaştırması',
  'business.compareWith': 'Bu işletmeyi {1} içindeki ortalama {0} ile karşılaştırın',
  'business.basedOnBusinesses': '{0} işletmeye dayanarak',
  'business.pricingNote': 'Fiyatlandırma Hakkında Not',
  'business.pricingExplanation': 'Daha yüksek yıldız derecesi daha iyi algılanan değer/erişilebilirlik gösterir',
  'business.cityAverage': 'Şehir Ortalaması',
  'business.thisBusiness': 'Bu İşletme',
  // Weekdays
  'weekdays.monday': 'Pazartesi',
  'weekdays.tuesday': 'Salı',
  'weekdays.wednesday': 'Çarşamba',
  'weekdays.thursday': 'Perşembe',
  'weekdays.friday': 'Cuma',
  'weekdays.saturday': 'Cumartesi',
  'weekdays.sunday': 'Pazar',
  // Reviews translations
  'reviews.title': 'Yorumlar',
  'reviews.googleReviews': 'Google Yorumları',
  'reviews.noReviews': 'Henüz yorum yok',
  'reviews.showAll': 'Tüm yorumları göster',
  'reviews.writePlaceholder': 'Bir yorum yazın...',
  'reviews.submit': 'Yorumu Gönder',
  'reviews.viewMore': 'Daha fazla görüntüle',
  'reviews.viewLess': 'Daha az görüntüle',
  // Activity tab translations
  'profile.upvotes': 'Beğeniler',
  'profile.downvotes': 'Beğenmemeler',
  // Loading messages
  'loading.default': 'Yükleniyor',
  'loading.favorites': 'Favorileriniz yükleniyor',
  'loading.profile': 'Profil yükleniyor',
  // Month abbreviations
  'months.jan': 'Oca',
  'months.feb': 'Şub',
  'months.mar': 'Mar',
  'months.apr': 'Nis',
  'months.may': 'May',
  'months.jun': 'Haz',
  'months.jul': 'Tem',
  'months.aug': 'Ağu',
  'months.sep': 'Eyl',
  'months.oct': 'Eki',
  'months.nov': 'Kas',
  'months.dec': 'Ara',
  'rating.rateThisBusiness': 'Bu işletmeyi değerlendirin',
  'rating.guestNotice': 'Misafir olarak değerlendirebilirsiniz, ancak giriş yapmak spam önlememize yardımcı olur',
  'rating.doneRating': 'Değerlendirme Tamamlandı',
  'rating.submitError': 'Değerlendirme gönderilemedi',
  'rating.selectCategory': 'Lütfen en az bir kategoriyi değerlendirin',
  'rating.thankYou': 'Değerlendirmeleriniz için teşekkürler!',
  'rating.yourRating': 'Değerlendirmeniz',
  'rating.clickToRate': 'Değerlendirmek için tıklayın',
  'categories.all': 'Tüm Kategoriler',
  'categories.restaurant': 'Restoran',
  'categories.cafe': 'Kafe',
  'categories.bar': 'Bar',
  'categories.hotel': 'Otel',
  'categories.shopping': 'Alışveriş',
  'categories.generalShopping': 'Genel Mağaza',
  'categories.generalstore': 'Genel Mağaza',
  'categories.entertainment': 'Eğlence',
  'categories.health': 'Sağlık',
  'categories.beauty': 'Güzellik',
  'categories.education': 'Eğitim',
  'categories.transport': 'Ulaştırma',
  'categories.fastFood': 'Hızlı Yemek',
  'categories.gym': 'Spor Salonu',
  'categories.pub': 'Pub',
  'categories.electronicsStore': 'Elektronik Mağazası',
  'categories.wellnessCenter': 'Sağlık Merkezi',
  'categories.shoppingMall': 'Alışveriş Merkezi',
  'categories.movieTheater': 'Sinema',
  'categories.hamburgerRestaurant': 'Hamburger Restoranı',
  'categories.theater': 'Tiyatro',
  'categories.puppetTheater': 'Kukla Tiyatrosu',
  'categories.museum': 'Müze',
  'categories.confectioneryShop': 'Şekerci',
  'categories.shawarmaRestaurant': 'Şavarma Restoranı',
  'categories.swimmingPool': 'Yüzme Havuzu',
  'categories.bakery': 'Fırın',
  'categories.supermarket': 'Süpermarket ve Hipermarket',
  'categories.supermarketandhypermarket': 'Süpermarket ve Hipermarket',
  'categories.iceCream': 'Dondurma',
  'categories.coffeeShop': 'Kahve Dükkanı',
  'categories.sportsComplex': 'Spor Kompleksi',
  'categories.clothingStore': 'Giyim Mağazası',
  'categories.giftShop': 'Hediyelik Eşya Dükkanı',
  'categories.market': 'Pazar',
  'categories.park': 'Park',
  'categories.touristAttraction': 'Turistik Yer',
  'categories.winery': 'Şaraphane',
  'categories.library': 'Kütüphane',
  'categories.pizza': 'Pizzacı',
  'categories.homeGoodsStore': 'Ev Eşyaları Mağazası',
  'categories.buildingMaterialsStore': 'İnşaat Malzemeleri Mağazası',
  'categories.automobile': 'Otomobil',
  'categories.parfumeandcosmetics': 'Parfüm ve Kozmetik',
  'categories.jewelryandaccessories': 'Mücevher ve Aksesuarlar',
  'categories.bookandstationery': 'Kitap ve Kırtasiye',
  'categories.alcoholandbeverages': 'Alkol ve İçecekler',
  'categories.furnitureandtextiles': 'Mobilya ve Tekstil',
  'categories.lighting': 'Aydınlatma',
  // Lowercase category keys for radar chart
  'categories.hamburgerrestaurant': 'Hamburger Restoranı',
  'categories.fastfood': 'Hızlı Yemek',
  'categories.icecream': 'Dondurma',
  'categories.coffeeshop': 'Kahve Dükkanı',
  'categories.electronicsstore': 'Elektronik Mağazası',
  'categories.wellnesscenter': 'Sağlık Merkezi',
  'categories.shoppingmall': 'Alışveriş Merkezi',
  'categories.movietheater': 'Sinema',
  'categories.confectioneryshop': 'Şekerci',
  'categories.shawarmarestaurant': 'Şavarma Restoranı',
  'categories.swimmingpool': 'Yüzme Havuzu',
  'categories.sportscomplex': 'Spor Kompleksi',
  'categories.clothingstore': 'Giyim Mağazası',
  'categories.giftshop': 'Hediyelik Eşya Dükkanı',
  'categories.toystore': 'Oyuncak Dükkanı',
  'categories.touristattraction': 'Turistik Yer',
  'categories.homegoodsstore': 'Ev Eşyaları Mağazası',
  'categories.buildingmaterialsstore': 'İnşaat Malzemeleri Mağazası',
  'categories.puppettheater': 'Kukla Tiyatrosu',
  'cities.tbilisi': 'Tiflis',
  'cities.batumi': 'Batum',
  'cities.kutaisi': 'Kutaisi',
  'cities.rustavi': 'Rustavi',
  'cities.gori': 'Gori',
  'cities.zugdidi': 'Zugdidi',
  'cities.poti': 'Poti',
  'cities.telavi': 'Telavi',
  'cities.mtskheta': 'Mtskheta',
  'cities.borjomi': 'Borjomi',
  'cities.kobuleti': 'Kobuleti',
  'cities.akhaltsikhe': 'Akhaltsikhe',
  'cities.sachkhere': 'Sachkhere',
  'cities.samtredia': 'Samtredia',
  'cities.senaki': 'Senaki',
  'cities.khashuri': 'Khashuri',
  'cities.chiatura': 'Chiatura',
  'cities.kvariati': 'Kvariati',
  'cities.baghdati': 'Baghdati',
  'cities.sairme': 'Sairme',
  'cities.kaspi': 'Kaspi',
  'cities.tsalka': 'Tsalka',
  'cities.tsalenjikha': 'Tsalenjikha',
  'cities.tskaltubo': 'Tskaltubo',
  'cities.khoni': 'Khoni',
  'cities.martvili': 'Martvili',
  'cities.vani': 'Vani',
  'cities.kareli': 'Kareli',
  'cities.marneuli': 'Marneuli',
  'cities.lanchkhuti': 'Lanchkhuti',
  'cities.shekvetili': 'Shekvetili',
  'cities.chkhorotsku': 'Chkhorotsku',
  'cities.ureki': 'Ureki',
  'cities.gonio': 'Gonio',
  'cities.anaklia': 'Anaklia',
  'cities.ushguli': 'Ushguli',
  'cities.lentekhi': 'Lentekhi',
  'cities.tsageri': 'Tsageri',
  'cities.akhalkalaki': 'Akhalkalaki',
  'cities.dusheti': 'Dusheti',
  'cities.saguramo': 'Saguramo',
  'cities.tianeti': 'Tianeti',
  'cities.akhmeta': 'Akhmeta',
  'cities.sagarejo': 'Sagarejo',
  'cities.sighnaghi': 'Sighnaghi',
  'cities.kvareli': 'Kvareli',
  'cities.gurjaani': 'Gurjaani',
  'cities.lagodekhi': 'Lagodekhi',
  'cities.dedoplistskaro': 'Dedoplistskaro',
  'cities.ninotsminda': 'Ninotsminda',
  'cities.dmanisi': 'Dmanisi',
  'cities.bolnisi': 'Bolnisi',
  'cities.gardabani': 'Gardabani',
  'cities.abasha': 'Abasha',
  'cities.tkibuli': 'Tkibuli',
  'cities.bakhmaro': 'Bakhmaro',
  'cities.chokhatauri': 'Chokhatauri',
  'cities.shuakhevi': 'Shuakhevi',
  'cities.keda': 'Keda',
  'cities.khulo': 'Khulo',
  'cities.manglisi': 'Manglisi',
  // Missing cities previously without translations
  'cities.bakuriani': 'Bakuriani',
  'cities.gudauri': 'Gudauri',
  'cities.mestia': 'Mestia',
  'cities.oni': 'Oni',
  'cities.ozurgeti': 'Ozurgeti',
  'cities.stepantsminda': 'Stepantsminda',
  'cities.terjola': 'Terjola',
  'cities.zestafoni': 'Zestafoni',
  'cities.ambrolauri': 'Ambrolauri',
  'cities.natakhtari': 'Natakhtari',
  // Review translations - additional
  'reviews.pleaseEnterReview': 'Lütfen bir yorum girin',
  'reviews.invalidReview': 'Geçersiz Yorum',
  'reviews.onlyBadWordsError': 'Yorum yalnızca uygunsuz içerik içeremez',
  'reviews.spamContentError': 'Yorumunuz tanıtım veya spam içeriği içeriyor ve gönderilemez.',
  'reviews.pleaseWait': 'Lütfen bekleyin',
  'reviews.rateLimitError': '30 saniye sonra yeni bir yorum gönderebilirsiniz',
  'reviews.mustBeLoggedIn': 'Yorum göndermek için giriş yapmalısınız',
  'reviews.duplicateReview': 'Tekrar Eden Yorum',
  'reviews.somethingWentWrong': 'Bir şeyler yanlış gitti.',
  'reviews.submitFailedTryAgain': 'Yorum gönderme başarısız, lütfen tekrar deneyin.',
  'reviews.reviewSubmitted': 'Yorumunuz gönderildi',
  'reviews.submitFailed': 'Yorum gönderme başarısız',
  'reviews.spamWarning': 'Yorumunuz bir bağlantı veya tanıtım içeriği içeriyor gibi görünüyor.',
  'reviews.badWordsOnlyWarning': 'Yorum yalnızca uygunsuz kelimeler içeremez.',
  'reviews.characterLimitReached': 'Maksimum karakter sınırına ulaşıldı',
  'reviews.submitting': 'Gönderiliyor...',
  'pages.about.title': 'Hakkımızda',
  'pages.about.welcome': 'GoodVote.ge\'ye hoş geldiniz – bölgenizdeki en iyi işletmeleri keşfetmek, incelemek ve değerlendirmek için başvuracağınız platform.',
  'pages.about.belief': 'GoodVote\'ta yerel bilginin güçlü olduğuna inanıyoruz. Samimi bir kafe, romantik bir restoran veya şehrinizdeki gizli bir mücevher arıyor olun, platformumuz gerçek kullanıcı geri bildirimlerine dayalı güvenli kararlar vermenize yardımcı olur.',
  'pages.about.description': 'İşletmeler hakkında güncel bilgi sağlamak için Google\'ın işletme verisi API\'sini kullanıyor ve ardından size, topluluğa, oy verme, değerlendirme ve tavsiye etme imkanı sunuyoruz.',
  'pages.about.independence': 'GoodVote bağımsız ve ücretsiz kullanıma yönelik, sadelik göz önünde bulundurularak inşa edilmiştir. Erişim için ücret almıyoruz ve deneyiminizi ödemelerle karmaşıklaştırmıyoruz.',
  'pages.about.why.title': 'Neden varız:',
  'pages.about.why.point1': 'Kullanıcıları yerel hizmetler konusunda daha iyi seçimler yapmaya güçlendirmek için.',
  'pages.about.why.point2': 'Kalite ve şeffaflığı vurgulayarak yerel işletmeleri desteklemek için.',
  'pages.about.why.point3': 'Gürültü ve önyargı olmadan yorumlar için güvenilir bir alan oluşturmak için.',
  'pages.about.companion': 'Yeni bir şehirde seyahat eden olun ya da mahalleni keşfeden yerel biri, GoodVote.ge etrafınızdaki en iyisini keşfetmek için dijital arkadaşınızdır.',
  'pages.contact.title': 'Bize Ulaşın',
  'pages.contact.description': 'Sorularınız, önerileriniz var mı veya iletişime geçmek mi istiyorsunuz? Sizden haber almak isteriz.',
  'pages.contact.button': 'İletişim',
  'pages.contact.emailLabel': 'E-posta adresimiz:',
  'pages.terms.title': 'GoodVote.ge Hizmet Şartları',
  'pages.terms.effective': 'Yürürlük Tarihi: 19 Temmuz 2025',
  'pages.terms.welcome': 'GoodVote.ge\'ye hoş geldiniz! Web sitemizi kullanarak aşağıdaki Hizmet Şartlarını kabul etmiş olursunuz.',
  'pages.terms.use.title': '1. Hizmetimizin Kullanımı',
  'pages.terms.use.description': 'GoodVote.ge yerel işletmeleri keşfetmek ve değerlendirmek için bir platformdur.',
  'pages.terms.use.point1': 'Google ve diğer kaynaklardan işletme verilerini çekmek ve görüntülemek için halka açık API\'leri kullanıyoruz. Bu verilerin sahipliğini iddia etmiyoruz.',
  'pages.terms.use.point2': 'Web sitesini yasa dışı, zararlı veya kötüye kullanım amaçları için kullanamazsınız.',
  'pages.terms.use.point3': 'Hizmetlerimizi hacklemeye, kazımaya veya tersine mühendislik yapmaya çalışmamalısınız.',
  'pages.terms.content.title': '2. Kullanıcı Tarafından Oluşturulan İçerik',
  'pages.terms.content.point1': 'Kullanıcılar işletmeler hakkında yorumlar, oylar ve geri bildirimler gönderebilir.',
  'pages.terms.content.point2': 'Yayınladığınız içerikten siz sorumlusunuz.',
  'pages.terms.content.point3': 'Saldırgan, yanıltıcı veya yasaları ihlal eden içerikleri kaldırabiliriz.',
  'pages.terms.account.title': '3. Hesap Yönetimi ve Giriş',
  'pages.terms.account.point1': 'Yorumları göndermek veya favorileri kaydetmek gibi bazı özellikler giriş yapmanızı gerektirebilir.',
  'pages.terms.account.point2': 'Hesabınızın güvenliği ve hesabınız altında gerçekleşen herhangi bir faaliyetten siz sorumlusunuz.',
  'pages.terms.account.point3': 'Google kullanarak kaydolma veya giriş yapmayı seçerseniz, Google profil bilgilerinizi (ad ve e-posta) hesabınızı oluşturmak ve yönetmek için kullanmamıza izin vermeyi kabul etmiş olursunuz.',
  'pages.terms.account.point4': 'Giriş bilgilerinizi paylaşmamalı veya başka birini taklit etmemelisiniz.',
  'pages.terms.ip.title': '4. Fikri Mülkiyet',
  'pages.terms.ip.point1': 'Tüm web sitesi kodu, tasarım ve orijinal içerik GoodVote.ge\'ye aittir.',
  'pages.terms.ip.point2': 'Google işletme verileri, logoları ve diğer üçüncü taraf ticari markaları ilgili sahiplerine aittir.',
  'pages.terms.thirdparty.title': '5. Üçüncü Taraf Hizmetleri',
  'pages.terms.thirdparty.point1': 'Web sitemizi çalıştırmak için arka uç ve kullanıcı kimlik doğrulaması için Supabase ve işletme bilgilerini görüntülemek için Google API\'leri dahil olmak üzere üçüncü taraf hizmetlerini kullanıyoruz.',
  'pages.terms.thirdparty.point2': 'Bu üçüncü taraf hizmetlerden gelen verilerin doğruluğu veya bütünlüğünden sorumlu değiliz.',
  'pages.terms.thirdparty.point3': 'Hizmetimizin kullanımınız aynı zamanda Supabase Hizmet Şartları ve Google Hizmet Şartları dahil olmak üzere üçüncü taraf sağlayıcılarımızın hizmet şartlarına da tabidir.',
  'pages.terms.liability.title': '6. Sorumluluk Sınırlaması',
  'pages.terms.liability.point1': 'Sitenin kullanımından kaynaklanan herhangi bir hasardan sorumlu değiliz.',
  'pages.terms.liability.point2': 'Hizmet herhangi bir garanti olmaksızın "olduğu gibi" sağlanır.',
  'pages.terms.changes.title': '7. Şartlardaki Değişiklikler',
  'pages.terms.changes.point1': 'Bu Hizmet Şartları zaman zaman güncellenebilir. Bu sayfada yeni şartları yayınlayarak önemli değişiklikleri size bildireceğiz.',
  'pages.terms.changes.point2': 'Herhangi bir değişiklik sonrasında sitenin sürekli kullanımı güncellenen şartları kabul ettiğiniz anlamına gelir.',
  'pages.terms.termination.title': '8. Sonlandırma',
  'pages.terms.termination.description': 'Bu Hizmet Şartlarını ihlal ettiğine inandığımız veya hizmetin diğer kullanıcılarına veya bize zarar verdiğine inandığımız herhangi bir davranış veya herhangi bir başka nedenle, hesabınızı ve hizmete erişimi kendi takdirimize bağlı olarak, bildirim yapmadan askıya alma veya sonlandırma hakkını saklı tutuyoruz.',
  'pages.terms.contact.title': '9. İletişim',
  'pages.terms.contact.text': 'Bu şartlar hakkında sorular için bize e-posta gönderin:',
  'pages.privacy.title': 'GoodVote.ge Gizlilik Politikası',
  'pages.privacy.effective': 'Yürürlük Tarihi: 19 Temmuz 2025',
  'pages.privacy.welcome': 'GoodVote.ge\'ye hoş geldiniz! Bu gizlilik politikası web sitemizi ve hizmetlerimizi kullandığınızda bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar.',
  'pages.privacy.collect.title': '1. Topladığımız Bilgiler',
  'pages.privacy.collect.intro': 'Şunları toplayabiliriz:',
  'pages.privacy.collect.point1': 'Adınız ve e-postanız (hesap oluşturursanız veya bizimle iletişime geçerseniz).',
  'pages.privacy.collect.point2': 'IP adresi, tarayıcı türü, cihaz bilgisi (çerezler veya günlükler aracılığıyla otomatik olarak).',
  'pages.privacy.collect.point3': 'Gönderdiğiniz yorumlar veya oylar.',
  'pages.privacy.collect.googleTitle': '1.1. Google Sign-In\'den Toplanan Bilgiler',
  'pages.privacy.collect.googleDescription': 'Google hesabınızı kullanarak kaydolmayı veya giriş yapmayı seçerseniz, Google profilinizden belirli bilgilere erişmek için bize izin veriyorsunuz.',
  'pages.privacy.collect.googleName':  'Adınız:',
  'pages.privacy.collect.googleNameDescription': '.../auth/userinfo.profile kapsamından hesabınızı kişiselleştirmek için adınızı ve soyadınızı topluyoruz.',
  'pages.privacy.collect.googleEmail': 'E-posta Adresiniz:',
  'pages.privacy.collect.googleEmailDescription': '.../auth/userinfo.email kapsamından birincil e-posta adresinizi topluyoruz.',
  'pages.privacy.collect.googleNote': 'Bu bilgileri kullanıcı hesabınızı oluşturmak ve profilinizi önceden doldurmak için kullanıyoruz. Kişiler, takvim veya dosyalar gibi Google hesabınızdaki diğer bilgilere erişmez, saklamaz veya paylaşmayız.',
  'pages.privacy.use.title': '2. Bilgilerinizi Nasıl Kullanıyoruz',
  'pages.privacy.use.intro': 'Bilgilerinizi şunlar için kullanıyoruz:',
  'pages.privacy.use.point1': 'Hizmetlerimizi sağlamak ve geliştirmek.',
  'pages.privacy.use.point2': 'Yorumlarınızı ve değerlendirmelerinizi işletme listelerinde görüntülemek.',
  'pages.privacy.use.point3': 'Bildirimler veya güncellemeler göndermek (kabul ettiyseniz).',
  'pages.privacy.use.point4': 'Kullanım kalıplarını analiz ederek kullanıcı deneyimini geliştirmek.',
  'pages.privacy.use.point5': 'Google aracılığıyla giriş yaptığınızda hesabınızı oluşturmak ve yönetmek için.',
  'pages.privacy.cookies.title': '3. Çerezler ve İzleme',
  'pages.privacy.cookies.text': 'Site işlevselliğini ve analitiği geliştirmek için çerezler kullanıyoruz.',
  'pages.privacy.thirdparty.title': '4. Üçüncü Taraf Hizmetleri',
  'pages.privacy.thirdparty.text': 'Web sitemizi ve hizmetlerimizi işletmemize yardımcı olmak için üçüncü taraf hizmetlerini kullanabiliriz.',
  'pages.privacy.thirdparty.supabase': 'Supabase:',
  'pages.privacy.thirdparty.supabaseDescription': 'Arka uç hizmet sağlayıcımız olarak Supabase kullanıyoruz. Adınız ve e-postanız dahil hesap verileriniz platformlarında güvenli bir şekilde saklanır.',
  'pages.privacy.thirdparty.analytics': 'Google Analytics:',
  'pages.privacy.thirdparty.analyticsDescription': 'Web sitesi kullanımını analiz etmek için Google Analytics kullanıyoruz.',
  'pages.privacy.sharing.title': '5. Veri Paylaşımı',
  'pages.privacy.sharing.intro': 'Kişisel bilgilerinizi satmıyoruz. Verileri yalnızca şu durumlarda paylaşabiliriz:',
  'pages.privacy.sharing.point1': 'İzninizle.',
  'pages.privacy.sharing.point2': 'Yasal uyumluluk veya haklarımızı korumak için.',
  'pages.privacy.sharing.point3': 'Siteyi işletmemize yardımcı olan yukarıda listelenen üçüncü taraf hizmet sağlayıcılarıyla.',
  'pages.privacy.security.title': '6. Veri Güvenliği',
  'pages.privacy.security.text': 'Supabase gibi güvenli platformlarda bilgilerinizi saklama dahil olmak üzere verilerinizi korumak için makul güvenlik önlemleri uyguluyoruz.',
  'pages.privacy.rights.title': '7. Haklarınız',
  'pages.privacy.rights.description': 'Verilerinize erişim, düzeltme veya silme hakkınız vardır.',
  'pages.privacy.rights.point1': 'Hesap ayarlarınızda profil bilgilerinizi yönetebilirsiniz.',
  'pages.privacy.rights.point2': 'Kişisel verilerinize erişim, düzeltme veya silme talebinde bulunmak için contact@goodvote.ge adresinden bizimle iletişime geçin.',
  'pages.privacy.rights.point3': 'Tarayıcı ayarlarınız aracılığıyla çerezlerden veya analitik izlemeden çıkabilirsiniz.',
  'pages.privacy.changes.title': '8. Bu Politikadaki Değişiklikler',
  'pages.privacy.changes.text': 'Bu Gizlilik Politikası zaman zaman güncellenebilir. Yeni yürürlük tarihi ile güncellemeleri bu sayfada yayınlayacağız.',
  'pages.privacy.contact.title': '9. İletişim',
  'pages.privacy.contact.text': 'Bu Gizlilik Politikası veya veri uygulamalarımız hakkında herhangi bir sorunuz varsa lütfen bizimle iletişime geçin:',

  // Review reactions
  'reviews.like': 'Beğen',
  'reviews.dislike': 'Beğenme',
  'reviews.signInToReact': 'Bu yoruma tepki vermek için lütfen giriş yapın',
  'reviews.reactionError': 'Tepki güncellenemedi',

  // Badges
  'badges.newbie': 'Acemi',
  'badges.explorer': 'Kaşif',
  'badges.helper': 'Yardımcı',
  'badges.trustedLocal': 'Güvenilir Yerel',
  'badges.localExpert': 'Yerel Uzman',
  'badges.cityMaster': 'Şehir Ustası',
  'badges.countryMaster': 'Ülke Ustası',
  'badges.cleanlinessGuardian': 'Temizlik Koruyucusu',
  'badges.priceScout': 'Fiyat İzci',
  'badges.serviceJudge': 'Hizmet Yargıcı',
  'badges.interiorCritic': 'İç Mekan Eleştirmeni',

  // Badge descriptions
  'badges.desc.newbie': '1 ile 9 arası yorum/değerlendirme',
  'badges.desc.explorer': '10 ile 29 arası yorum/değerlendirme',
  'badges.desc.helper': '30 ile 49 arası yorum/değerlendirme',
  'badges.desc.trustedLocal': '50 ile 99 arası yorum/değerlendirme',
  'badges.desc.localExpert': '100 ile 199 arası yorum/değerlendirme',
  'badges.desc.cityMaster': '200 ile 299 arası yorum/değerlendirme',
  'badges.desc.countryMaster': '300+ yorum/değerlendirme',
  'badges.desc.cleanlinessGuardian': '50+ temizlik değerlendirmesi',
  'badges.desc.priceScout': '50+ fiyat değerlendirmesi',
  'badges.desc.serviceJudge': '50+ hizmet değerlendirmesi',
  'badges.desc.interiorCritic': '50+ iç mekan değerlendirmesi',

  // Badge requirements
  'badges.req.newbie': '1 ile 9 arası yorum gönderin',
  'badges.req.explorer': '10 ile 29 arası yorum gönderin',
  'badges.req.helper': '30 ile 49 arası yorum gönderin',
  'badges.req.trustedLocal': '50 ile 99 arası yorum gönderin',
  'badges.req.localExpert': '100 ile 199 arası yorum gönderin',
  'badges.req.cityMaster': '200 ile 299 arası yorum gönderin',
  'badges.req.countryMaster': '300+ yorum gönderin',
  'badges.req.cleanlinessGuardian': 'Temizliği 50+ kez değerlendirin',
  'badges.req.priceScout': 'Fiyatı 50+ kez değerlendirin',
  'badges.req.serviceJudge': 'Hizmeti 50+ kez değerlendirin',
  'badges.req.interiorCritic': 'İç mekanı 50+ kez değerlendirin',

  'badges.title': 'Rozetleriniz',
  'badges.allBadges': 'Tüm Rozetler',
  'badges.infoSheet.title': 'Rozet Nasıl Kazanılır',
  'badges.progress': 'İlerleme',
  'badges.earned': 'Kazanıldı',
  'badges.primaryBadges': 'Birincil Rozetler',
  'badges.specialtyBadges': 'Özel Rozetler',
  'badges.selectToDisplay': 'Yorumlarda gösterilecek rozeti seçin',
  'badges.displayBadgeUpdated': 'Görüntülenen rozet güncellendi',
  'badges.displayBadgeUpdatedDesc': 'Seçtiğiniz rozet artık tüm yorumlarınızda görünecek',
  'badges.displayBadgeUpdateError': 'Görüntülenen rozet güncellenemedi',
  'badges.stats.current': 'Mevcut yorumlar -',
  'badges.stats.currentCleanliness': 'Mevcut temizlik değerlendirmeleri -',
  'badges.stats.currentPricing': 'Mevcut fiyat değerlendirmeleri -',
  'badges.stats.currentService': 'Mevcut servis değerlendirmeleri -',
  'badges.stats.currentInterior': 'Mevcut iç mekan değerlendirmeleri -',
  
  // Earned badges section
  'badges.earnedBadges': 'Kazanılan Rozetler',
  
  // Auth sign out messages
  'auth.signedOutSuccess': 'Başarıyla çıkış yapıldı',
  'auth.signOutError': 'Çıkış yapılamadı. Lütfen tekrar deneyin.',
  
  // Review toast messages
  'reviews.updateSuccess': 'Yorum başarıyla güncellendi',
  'reviews.updateError': 'Yorum güncellenemedi',
  'reviews.deleteSuccess': 'Yorum başarıyla silindi',
  'reviews.deleteError': 'Yorum silinemedi',
  'reviews.submitSuccess': 'Yorum başarıyla gönderildi!',
  
  // Delete confirmation dialog
  'dialog.areYouAbsolutelySure': 'Kesinlikle emin misiniz?',
  'dialog.deleteReviewWarning': 'Bu işlem geri alınamaz. Yorumunuz kalıcı olarak silinecektir.',
  'dialog.delete': 'Sil',
  'dialog.cancel': 'İptal',
  
  // Welcome toast and profile
  'auth.signedInSuccessfully': 'Başarıyla giriş yapıldı',
  'auth.welcome': 'Hoş geldiniz',
  'auth.dismiss': 'Kapat',
  'profile.characters': 'karakter',
};
